import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade-up reveal. Renders a motion.div carrying `className`, so it can
// stand in directly for a styled div (cards, section headers, etc.).
// `mount` animates on mount (hero); otherwise animates when scrolled into view.
export const Reveal = ({
  children,
  className,
  style,
  delay = 0,
  y = 24,
  mount = false,
}) => {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  }

  const target = { opacity: 1, y: 0 };
  const props = mount
    ? { initial: { opacity: 0, y }, animate: target }
    : {
        initial: { opacity: 0, y },
        whileInView: target,
        viewport: { once: true, margin: "-80px" },
      };

  return (
    <motion.div
      className={className}
      style={style}
      transition={{ duration: 0.55, ease: EASE, delay }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
